import { ApiProperty } from "@nestjs/swagger";

export class PlantInputRequest{
    @ApiProperty()
    plantId?:number;
}